export default "__VITE_ASSET__Cd9d57BY__"